import React, { ReactNode, useEffect, useRef, useState } from "react";
import Steps from "../Steps/Steps";
import { BtnSize, BtnType, Button } from "../Button";
import { Colors } from "../../Constants/colors";
interface Props {
  onStepChange: (step: number) => unknown;
  stepComponents: ReactNode[];
  submitText?: string;
  onSubmit: () => unknown;
  isSubmitLoading: boolean;
}
const StepWrapper = ({
  onStepChange,
  stepComponents,
  submitText = "Submit",
  onSubmit,
  isSubmitLoading = false,
}: Props) => {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = stepComponents.length;

  const containerRef = useRef<HTMLDivElement>(null);
  const childRef = useRef<HTMLDivElement[]>([]);
  const [childHeight, setChildHeight] = useState<number[]>([]);

  const [transform, setTransform] = useState(0);

  const scrollToContainterTop = () => {
    if (containerRef && containerRef.current) {
      const yPos = containerRef.current.offsetTop;
      window.scrollTo({
        top: yPos,
        behavior: "smooth",
      });
    }
  };

  const scrollToNextStep = () => {
    if (!onStepChange(currentStep)) return;

    const nextStep = currentStep + 1;

    if (nextStep <= totalSteps) {
      setTransform(-(100 * (nextStep - 1)));
      setCurrentStep(nextStep);
      scrollToContainterTop();
    }
  };

  const scrollToPrevoiusStep = () => {
    const previousStep = currentStep - 1;
    if (previousStep >= 1) {
      setTransform(-(100 * (previousStep - 1)));
      setCurrentStep(previousStep);
      scrollToContainterTop();
    }
  };

  // useEffect(() => {
  //   console.log("It is running");
  //   if (childHeight.length <= stepComponents.length) {
  //     const tempHeightArray: number[] = [];

  //     stepComponents.forEach((child, index) => {
  //       if (childRef && childRef.current[index]) {
  //         const height = childRef.current[index]?.clientHeight;
  //         tempHeightArray.push(height);
  //       }
  //     });
  //     console.log(tempHeightArray, "tempHeightArray");
  //     // Update the state only once with the accumulated heights
  //     setChildHeight(tempHeightArray);
  //   }
  // }, [childRef, childHeight, stepComponents]);

  useEffect(() => {
    console.log("This is it");
    if (
      childRef.current.length === stepComponents.length &&
      childHeight.length === 0
    ) {
      const tempHeightArray: number[] = [];

      childRef.current.forEach((child) => {
        if (child) {
          tempHeightArray.push(child.clientHeight);
        }
      });

      setChildHeight(tempHeightArray);
    }
  }, [stepComponents]);

  return (
    <div ref={containerRef}>
      <Steps totalSteps={stepComponents.length} currentStep={currentStep} />
      <div
        className="mt-10 mb-10 flex"
        style={{
          maxHeight: `${childHeight[currentStep - 1]}px`,
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {stepComponents.map((children, index) => (
          <div
            ref={(ref) => {
              childRef.current[index] = ref as HTMLDivElement;
            }}
            className="h-fit"
            style={{
              minWidth: "100%",
              transform: `translateX(${transform}%)`,
              transition: "width 2s, height 2s, transform 0.6s",
            }}
          >
            {children}
          </div>
        ))}
      </div>

      <div
        className="w-full flex justify-end py-8"
        style={{ borderTop: `2px solid ${Colors.LightAshRose}` }}
      >
        <div className="flex gap-4 w-64">
          {currentStep > 1 ? (
            <Button
              text="Previous"
              btnSize={BtnSize.sm}
              btnType={BtnType.basic}
              onClick={scrollToPrevoiusStep}
            />
          ) : (
            <></>
          )}

          {currentStep < totalSteps ? (
            <Button
              text="Next"
              btnType={BtnType.primary}
              btnSize={BtnSize.sm}
              onClick={scrollToNextStep}
            />
          ) : currentStep === totalSteps ? (
            <Button
              text={submitText}
              btnType={BtnType.primary}
              btnSize={BtnSize.sm}
              onClick={onSubmit}
              loading={isSubmitLoading}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepWrapper;
